export default __webpack_public_path__ + "media/images/ui-bg_highlight-hard_100_f2f5f7_1x100-8a3f00ec71e249407e06f9273bf6aa20.png";